import { render, staticRenderFns } from "./InvoiceFooter.vue?vue&type=template&id=db3c9f04&"
import script from "./InvoiceFooter.vue?vue&type=script&lang=js&"
export * from "./InvoiceFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Projects/Coding/Nhafatura/appfactura-spa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VDivider,VFlex})
